/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Group_B_End_HeaderInputs */

const en_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group B End`)
};

const fr_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin du groupe B`)
};

const de_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe B Ende`)
};

const it_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fine del Gruppo B`)
};

const ru_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа B Конец`)
};

const es_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo B Final`)
};

const zh_cn2_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B组结束`)
};

const ja_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループB終了`)
};

const hi_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह बी का अंत`)
};

const pt_pt2_compare_event_groups_csv_group_b_end_header = /** @type {(inputs: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do Grupo B`)
};

/**
* | output |
* | --- |
* | "Group B End" |
*
* @param {Compare_Event_Groups_Csv_Group_B_End_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_group_b_end_header = /** @type {((inputs?: Compare_Event_Groups_Csv_Group_B_End_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Group_B_End_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "de") return de_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "it") return it_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "es") return es_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_group_b_end_header(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_group_b_end_header(inputs)
	return en_compare_event_groups_csv_group_b_end_header(inputs)
});